<template>
  <!-- MOBILE -->
  <JBottomSheet
    v-if="isMobile"
    v-model="internalModelValue"
    fullScreen
    hasPopstate
  >
    <ItinerarySummaryContent @close="close" />
  </JBottomSheet>

  <!-- DESKTOP -->
  <JDrawer v-else v-model="internalModelValue" floatClose>
    <ItinerarySummaryContent />
  </JDrawer>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import { onBeforeRouteLeave } from 'vue-router'
import { JBottomSheet, JDrawer } from '@journey/ui-kit'
import type { Emits, Props } from './ItinerarySummary.types'
import ItinerarySummaryContent from './ItinerarySummaryContent/ItinerarySummaryContent.vue'
import { useDevicePlatform } from '@/modules/Core/composables'

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
})
const emit = defineEmits<Emits>()

const internalModelValue = useVModel(props, 'modelValue', emit)

const { isMobile } = useDevicePlatform()

// CLOSE ON ROUTE CHANGE
function close() {
  internalModelValue.value = false
}

onBeforeRouteLeave(close)
</script>
